__turbopack_context__.v({
  "opened": "GVlxDa_opened",
});
